"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPlayCircle', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0M10.4649 7.3492L7.6649 5.3492C7.4209 5.174 7.1001 5.1524 6.8337 5.2884C6.5673 5.426 6.4001 5.6996 6.4001 5.9996V9.9996C6.4001 10.2996 6.5673 10.574 6.8337 10.7116C6.9489 10.7708 7.0753 10.7996 7.2001 10.7996C7.3641 10.7996 7.5265 10.75 7.6649 10.6508L10.4649 8.6508C10.6753 8.5004 10.8001 8.2588 10.8001 7.9996C10.8001 7.7412 10.6753 7.4988 10.4649 7.3492M8 14.4C4.4712 14.4 1.6 11.5288 1.6 8C1.6 4.4712 4.4712 1.6 8 1.6C11.5288 1.6 14.4 4.4712 14.4 8C14.4 11.5288 11.5288 14.4 8 14.4'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0M13.0811 9.1865L9.58112 6.6865C9.27612 6.4675 8.87512 6.4405 8.54212 6.6105C8.20912 6.7825 8.00012 7.1245 8.00012 7.4995V12.4995C8.00012 12.8745 8.20912 13.2175 8.54212 13.3895C8.68612 13.4635 8.84412 13.4995 9.00012 13.4995C9.20512 13.4995 9.40812 13.4375 9.58112 13.3135L13.0811 10.8135C13.3441 10.6255 13.5001 10.3235 13.5001 9.9995C13.5001 9.6765 13.3441 9.3735 13.0811 9.1865M10 18C5.589 18 2 14.411 2 10C2 5.589 5.589 2 10 2C14.411 2 18 5.589 18 10C18 14.411 14.411 18 10 18'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 0C5.3832 0 0 5.3832 0 12C0 18.6168 5.3832 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3832 18.6168 0 12 0M15.6973 11.0238L11.4973 8.02378C11.1313 7.76098 10.6501 7.72858 10.2505 7.93258C9.85095 8.13898 9.60015 8.54938 9.60015 8.99938V14.9994C9.60015 15.4494 9.85095 15.861 10.2505 16.0674C10.4233 16.1562 10.6129 16.1994 10.8001 16.1994C11.0461 16.1994 11.2897 16.125 11.4973 15.9762L15.6973 12.9762C16.0129 12.7506 16.2001 12.3882 16.2001 11.9994C16.2001 11.6118 16.0129 11.2482 15.6973 11.0238M12 21.6C6.7068 21.6 2.4 17.2932 2.4 12C2.4 6.7068 6.7068 2.4 12 2.4C17.2932 2.4 21.6 6.7068 21.6 12C21.6 17.2932 17.2932 21.6 12 21.6'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 0C7.1776 0 0 7.1776 0 16C0 24.8224 7.1776 32 16 32C24.8224 32 32 24.8224 32 16C32 7.1776 24.8224 0 16 0M20.9298 14.6984L15.3298 10.6984C14.8418 10.348 14.2002 10.3048 13.6674 10.5768C13.1346 10.852 12.8002 11.3992 12.8002 11.9992V19.9992C12.8002 20.5992 13.1346 21.148 13.6674 21.4232C13.8978 21.5416 14.1506 21.5992 14.4002 21.5992C14.7282 21.5992 15.053 21.5 15.3298 21.3016L20.9298 17.3016C21.3506 17.0008 21.6002 16.5176 21.6002 15.9992C21.6002 15.4824 21.3506 14.9976 20.9298 14.6984M16 28.8C8.94241 28.8 3.20001 23.0576 3.20001 16C3.20001 8.94237 8.94241 3.19997 16 3.19997C23.0576 3.19997 28.8 8.94237 28.8 16C28.8 23.0576 23.0576 28.8 16 28.8'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;